var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',[_c('p',{staticClass:"text-c"},[_vm._v("来晚了,优惠券领完了~")]),_c('el-image',{attrs:{"src":_vm.couponLw}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }